import InputText from '@/components/input-text'

import { SearchTypesComponentsProps } from '..'

export function DateSearchField({
  value,
  onChange,
}: SearchTypesComponentsProps) {
  return (
    <InputText
      id='date-search-field'
      aria-label='Campo de busca por data'
      type={'date'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}
